module.exports = require("web3-eth-personal");